
<template>
  <v-container>
    <drivers-list></drivers-list>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'Drivers',
  //mixins: [ validations ],
  components: {
    DriversList: () => import('@/_backoffice/_registrations/components/drivers/DriversList.vue'),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>